var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import baseStyles from '../Base.module.css';
import styles from './ImageInput.module.css';
import Label from '../Label';
import React from 'react';
import ImageInput from './ImageInput';
/** Приводит компонент к общему виду (внешняя обертка) */
export default function Wrapper(_a) {
    var _b, _c;
    var label = _a.label, labelType = _a.labelType, required = _a.required, restProps = __rest(_a, ["label", "labelType", "required"]);
    return (React.createElement("div", { className: classNames(baseStyles.control, (_b = {},
            _b[styles.controlTop] = labelType === 'top',
            _b)) },
        label && (React.createElement(Label, { label: label, labelType: labelType, required: required })),
        React.createElement("div", { className: classNames(baseStyles.inputContainer, (_c = {},
                _c[styles.inputContainerTop] = labelType === 'top',
                _c)) },
            React.createElement(ImageInput, __assign({ label: label, required: required }, restProps)))));
}
